import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability'

export enum Action {
  Manage = 'manage',
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete'
}

// type Subjects = InferSubjects<'Brand' | 'User'> | 'all'
export type AppAbility = Ability<[Action, any]>

// Default, unauthenticated abilities
export const createUnauthenticatedAbility = () => {
  const { build } = new AbilityBuilder<AppAbility>(Ability as AbilityClass<AppAbility>)

  return build({
    detectSubjectType: (object: any) => object.__typename
  })
}
